import { useState } from "react";
import { Pin, PinOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePins } from "@/lib/pins-context";
import type { PinType, PinEntityType } from "@dugads/shared";

interface PinRowButtonProps {
  pinType: PinType;
  entityType: PinEntityType;
  entityId: string;
}

/** Compact pin toggle for use inside table rows */
export function PinRowButton({ pinType, entityType, entityId }: PinRowButtonProps) {
  const { isPinned, addPin, removePin, pins } = usePins();
  const [loading, setLoading] = useState(false);

  const pinned = isPinned(entityType, entityId);
  const existingPin = pins.find(
    (p) => p.entity_type === entityType && p.entity_id === entityId,
  );

  async function handleToggle() {
    setLoading(true);
    try {
      if (pinned && existingPin) {
        await removePin(existingPin.id);
      } else {
        await addPin(pinType, entityType, entityId);
      }
    } catch {
      // Non-critical
    } finally {
      setLoading(false);
    }
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={handleToggle}
      disabled={loading}
      title={pinned ? "Unpin" : "Pin to sidebar"}
    >
      {pinned ? (
        <PinOff className="h-4 w-4 text-primary" />
      ) : (
        <Pin className="h-4 w-4" />
      )}
    </Button>
  );
}
